<template>
    <div>
        <el-form :model="ruleForm" :rules="rules" ref="tipForm" label-position="top" class="tip-form">
            <el-form-item :label="$t('paper.scorePerQuestion')" prop="topicScore">
                <el-input-number v-model="ruleForm.topicScore" controls-position="right" size="small" :min="1"></el-input-number>
            </el-form-item>
            <div class="tip-item">
                <p class="item-title"><span class="required">*</span>{{$t('res.singleView')}}</p>

                <div class="tip-num">
                    <div class="num-title"><span class="num-name">{{$t('paper.safeBag')}} ( {{view1SafeTotal}} )</span> </div>
                    <div class="num-input">
                        <span class="num-other">{{$t('paper.questionQuantity')}}</span>
                        <el-form-item>
                            <el-input-number v-model="view1Safe" controls-position="right" size="mini" :min="0" :max="view1SafeTotal"></el-input-number>
                        </el-form-item>
                        <span class="num-other">{{$t('paper.ge')}}</span>
                    </div>
                </div>
                <div class="tip-num">
                    <div class="num-title"><span class="num-name">{{$t('topic.simulatedBag')}} ( {{view1PackagesTotal}} )</span> </div>
                    <div class="num-input">
                        <span class="num-other">{{$t('paper.questionQuantity')}}</span>
                        <el-form-item>
                            <el-input-number v-model="view1Packages" controls-position="right" size="mini" :min="0" :max="view1PackagesTotal"></el-input-number>
                        </el-form-item>
                        <span class="num-other">{{$t('paper.ge')}}</span>
                    </div>
                </div>
                <div class="tip-num">
                    <div class="num-title"><span class="num-name">Tips危险品 ( {{view1TipsTotal}} )</span> </div>
                    <div class="num-input">
                        <span class="num-other">{{$t('paper.questionQuantity')}}</span>
                        <el-form-item>
                            <el-input-number v-model="view1Tips" controls-position="right" size="mini" :min="0" :max="view1TipsTotal"></el-input-number>
                        </el-form-item>
                        <span class="num-other">{{$t('paper.ge')}}</span>
                    </div>
                </div>
            </div>
            <div class="tip-item">
                <p class="item-title"><span class="required">*</span>{{$t('res.doubleView')}}</p>
                <div class="tip-num">
                    <div class="num-title"><span class="num-name">{{$t('paper.safeBag')}} ( {{view2SafeTotal}} )</span> </div>
                    <div class="num-input">
                        <span class="num-other">{{$t('paper.questionQuantity')}}</span>
                        <el-form-item>
                            <el-input-number v-model="view2Safe" controls-position="right" size="mini" :min="0" :max="view2SafeTotal"></el-input-number>
                        </el-form-item>
                        <span class="num-other">{{$t('paper.ge')}}</span>
                    </div>
                </div>
                <div class="tip-num">
                    <div class="num-title"><span class="num-name">{{$t('topic.simulatedBag')}} ( {{view2PackagesTotal}} )</span> </div>
                    <div class="num-input">
                        <span class="num-other">{{$t('paper.questionQuantity')}}</span>
                        <el-form-item>
                            <el-input-number v-model="view2Packages" controls-position="right" size="mini" :min="0" :max="view2PackagesTotal"></el-input-number>
                        </el-form-item>
                        <span class="num-other">{{$t('paper.ge')}}</span>
                    </div>
                </div>
                <div class="tip-num">
                    <div class="num-title"><span class="num-name">Tips危险品 ( {{view2TipsTotal}} )</span> </div>
                    <div class="num-input">
                        <span class="num-other">{{$t('paper.questionQuantity')}}</span>
                        <el-form-item>
                            <el-input-number v-model="view2Tips" controls-position="right" size="mini" :min="0" :max="view2TipsTotal"></el-input-number>
                        </el-form-item>
                        <span class="num-other">{{$t('paper.ge')}}</span>
                    </div>
                </div>
            </div>

            <!--左侧知识点-->
            <div class="count">
                <p>
                    {{$t('paper.totalQuestions')}}&ensp;
                    <el-input style="width:130px;margin-top: 20px"
                              :value="totalNum"
                              size="mini" disabled>
                    </el-input>
                    &ensp;{{$t('paper.dao')}}
                </p>
                <p>
                    {{$t('paper.paperScore')}}&ensp;
                    <el-input style="width:130px;margin-top: 20px"
                              :value="ruleForm.topicScore*totalNum"
                              size="mini" disabled>
                    </el-input>
                    &ensp;{{$t('paper.points')}}
                </p>
                <p>
                    {{$t('paper.passingMark')}}&ensp;
                    <el-input style="width:130px;margin-top: 20px"
                              :value="(ruleForm.topicScore*totalNum*passLine).toFixed(1)"
                              size="mini" disabled>
                    </el-input>
                    &ensp;{{$t('paper.points')}}
                </p>
            </div>
        </el-form>
<!--右侧知识点-->
        <div class="map-menu j-map-menu" :class="[kpShow ?'animated fadeInRight':'animated fadeOutRight']">
            <header class="map-title">
                <h3>{{$t('res.userLib')}}</h3>
                <i @click="kpShow=false" class="nucfont inuc-arrow-circle-right"></i>
            </header>
            <div class="map-content">
                <el-tree
                        ref="userImageTree"
                        :data="userTreeData"
                        show-checkbox
                        node-key="id"
                        @check-change="checkChange"
                        >
                        <span class="slot-t-node" slot-scope="{ node, data }">
                            <span class="node-name copy-move">
                                <span class="folder-type" :class="folderType(data.type)"></span>
                                <span>{{data.type == 3 ?($t('res.shareFrom',{share: data.name})) : (data.type == 2 ?(data.name + ' (' +data.size +')'):data.name)}}</span>
                            </span>
                       </span>
                    </el-tree>
            </div>
        </div>

        <div class="btn-group">
            <el-button type="primary" @click="finishStep" :disabled="totalNum == 0" style="padding: 14px 50px;font-size: 18px;">{{$t('paper.savePaper')}}</el-button>
        </div>
        <div class="fix-title" :class="[!kpShow ?'animated fadeInRight':'animated fadeOutUp']" @click="kpShow=true">{{$t('c.knowledgePoint')}}</div>

    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import {Debounce} from '@/utils'
    import api from '@/api';
    export default {
        props: ['passLine','paperName','pattern','type','knowledgeName','forLevel','difficulty'],
        data() {
            return {
                ruleForm: {
                    checkView: '1',
                    safeCount: 0,
                    topicScore: 2,
                },
                safeTotal:0,
                rules: {
                    checkView: {required: true },
                    topicScore: {required: true, message: this.$t('tip.questionScore'), trigger: 'change' },
                    safeCount: {required: true, message: this.$t('paper.warnEmpty'), trigger: 'change' },
                },
                directoryIDs: [],
                view1Safe: 0,
                view1Tips: 0,
                view1Packages: 0,
                view2Safe: 0,
                view2Tips: 0,
                view2Packages: 0,
                view1SafeTotal: 0,
                view1TipsTotal: 0,
                view1PackagesTotal: 0,
                view2SafeTotal: 0,
                view2TipsTotal: 0,
                view2PackagesTotal: 0,
                userTreeData: [],
                kpSelected: [],
                kpShow: true,
            }
        },
        created() {
            this.queryUserTree()
        },
        computed: {
            ...mapGetters([
                'knowledgeMenu',
            ]),
            totalNum(){
                return (this.view1Safe + this.view1Tips + this.view1Packages + this.view2Safe + this.view2Tips + this.view2Packages)
            }
        },
        methods: {
            //查询用户图库目录树
            queryUserTree(){
                let queryParams = {
                    viewMode: 'FilterDeletedKnowledge'
                }
                api.getDRUserTree(queryParams).then(res => {
                       this.userTreeData = res.package.children
                })
            },
            // 树的选中值发生变化
            checkChange: Debounce(function () {
                this.queryImageNum();
            }, 800),
            queryImageNum(){
                if (!this.$refs.userImageTree) return
                let checkedNodes = this.$refs.userImageTree.getCheckedNodes()
                let nodeArr = []
                console.log('选中节点有', checkedNodes);

                checkedNodes.forEach(ele => {
                    let type = ele.type
                    let id = ele.id
                    if (ele.type == 2){
                        nodeArr.push(id)
                    }
                })
                if (!nodeArr.length) {
                    this.view1Safe = this.view1Tips = this.view1Packages = this.view2Safe = this.view2Tips = this.view2Packages
                    = this.view1SafeTotal = this.view1TipsTotal = this.view1PackagesTotal = this.view2SafeTotal = this.view2TipsTotal = this.view2PackagesTotal=0
                    return
                }
                this.directoryIDs = nodeArr
                let queryParams = {
                    directoryIDs: this.directoryIDs
                }
                api.getUserKPImageCount(queryParams).then(res => {
                    if (res.package) {
                        let data = res.package
                        this.view1SafeTotal = data.view1Safe
                        this.view1TipsTotal = data.view1Tips
                        this.view1PackagesTotal = data.view1Packages
                        this.view2SafeTotal = data.view2Safe
                        this.view2TipsTotal = data.view2Tips
                        this.view2PackagesTotal = data.view2Packages
                        if (this.view1Safe > this.view1SafeTotal){
                            this.view1Safe = this.view1SafeTotal
                        }
                        if (this.view1Tips > this.view1TipsTotal){
                            this.view1Tips = this.view1TipsTotal
                        }
                        if (this.view1Packages > this.view1PackagesTotal){
                            this.view1Packages = this.view1PackagesTotal
                        }
                        if (this.view2Safe > this.view2SafeTotal){
                            this.view2Safe = this.view2SafeTotal
                        }
                        if (this.view2Tips > this.view2TipsTotal){
                            this.view2Tips = this.view2TipsTotal
                        }
                        if (this.view2Packages > this.view2PackagesTotal){
                            this.view2Packages = this.view2PackagesTotal
                        }
                    }
                })

            },
            //目录节点图标及颜色
            folderType(type){
                let color = 'nucfont '
                switch (type){
                    case 1:
                        color = color + 'inuc-folder folder'
                        break;
                    case 2:
                        color = color + 'inuc-wenjianjia_f image'
                        break;
                    case 3:
                        color = color + 'inuc-share share'
                        break;
                    default:
                        break
                }
                return color
            },
            handleChange(value) {
                let totalTip=0
                this.kpSelected.forEach(item=>{
                    totalTip += (item.dangerNum ||0) + (item.bagNum ||0)
                })
                this.totalNum = totalTip + (this.ruleForm.safeCount||0)
            },
            lastStep() {
                this.$emit('last-step')
            },
            finishStep() {
                this.$refs['tipForm'].validate((valid) => {
                    if (valid) {
                        if(this.totalNum == 0){
                            this.$message(this.$t('paper.paperNumGtOne'))
                            return
                        }
                        let submitData = {
                            custom: {
                                topicScore: this.ruleForm.topicScore,
                                directoryIDs: this.directoryIDs,
                                view1Safe: this.view1Safe,
                                view1Tips: this.view1Tips,
                                view1Packages: this.view1Packages,
                                view2Safe: this.view2Safe,
                                view2Tips: this.view2Tips,
                                view2Packages: this.view2Packages
                            },
                            title: this.paperName,
                            forLevel: this.forLevel,
                            knowledge: this.knowledgeName[this.knowledgeName.length-1],
                            passLine: this.passLine,
                            difficulty: this.difficulty,
                            type: this.type,
                            form: this.pattern
                        };
                        api.postTipImagePaper(submitData).then(res => {
                            this.$notify({
                                title: res.error,
                                message: this.$t('paper.buildupFast')+'!',
                                type: 'success',
                                duration: 2000
                            })
                            this.$emit('needUpdate')
                            this.$router.replace({name: 'myPaper'})
                        });
                    } else {
                        return false
                    }
                });
            }
        },
        watch: {},
        components: {}
    }
</script>
<style lang="scss">

</style>
<style scoped lang="scss">
    .tip-item{
        padding: 7px 5px;
        &.view-item{
            padding-bottom: 12px;
        }
        .item-title{
            margin-bottom: 5px;
            &.view-title{
                margin-bottom: 15px;
            }
            .required{
                color: #ff4081;
                padding-right: 3px;
            }
        }
        .no-kp{
            text-align: center;
            margin-top: 40px;
        }
        .tip-num{
            display: flex;
            width: 40%;
            height: 40px;
            line-height: 40px;
            margin-top: 10px;
            margin-bottom: 10px;
            justify-content: space-between;
            //width: 380px;
            &.kp-left{
                width: 368px;
                justify-content: space-between;
                margin-right: 60px;
                .num-other{
                    padding-left: 8px;
                    padding-right: 8px;
                }
                .num-title{
                    .num-name{
                        margin-right: 0px;
                    }
                }
            }
            .num-input{
                display: flex;
            }

            .num-title{
                color: #fff;

                .num-name{
                    background-color: #2e7faa;
                    padding: 3px 7px;
                    margin-right: 32px;
                }
            }
            .num-other{
                padding-left: 12px;
                padding-right: 12px;
            }
        }
        .kp-item{
            margin-bottom: 10px;
            .kp-top{
                /*line-height: 40px;*/
                padding-top: 5px;
                padding-bottom: 5px;
                .kp-name{
                    display: inline-block;
                    border: 1px solid #22bdff;
                    color: #22bdff;
                    padding: 4px 8px;
                    margin-right: 15px;
                }
                .kp-remove{
                    color: #afafaf;
                    cursor: pointer;
                    &:hover{
                        i{
                            font-size: 18px;
                        }
                    }
                }
            }
            .kp-content{
                display: flex;
            }

        }
    }
    .btn-group {
        margin-top: 60px;
        margin-bottom: 15px;
    }
    .map-menu {
        position: fixed;
        display: flex;
        flex-direction: column;
        top: 210px;
        right: 0;
        bottom: 120px;
        z-index: 1000;
        width: 260px;
        padding-bottom: 32px;
        .map-title {
            flex-shrink: 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 20px;
            background: #22b9ff;
            color: #fff;
            h3 {
                font-size: 18px;
                font-weight: 400;
            }
            .nucfont{
                font-size: 24px;
                border-radius: 2px;
                cursor: pointer;
                &:hover{
                    color: #e9f8ff;
                }

            }
        }
    }

    .map-menu .map-content {
        position: relative;
        flex: 1;
        width: 100%;
        padding: 5px 0 5px 0px;
        border-left: 1px solid #ababac;
        border-bottom: 1px solid #ababac;
        background: #fff;
        overflow-y: auto;
        min-height: 0;
    }


    .count {
        > p {
            display: inline-block;
            margin-right: 84px;
        }
    }
    .fix-title {
        position: fixed;
        top: 210px;
        right: 5px;
        padding: 6px 8px;
        background: #22b9ff;
        color: #fff;
        border-radius: 2px;
        opacity: 0;
        z-index: 100;
        cursor: pointer;
        transition: all .2s;
    }
    .slot-t-node{
        .node-name{
            padding-right: 3px;
            .folder-type{
                font-size: 16px;
                &.folder{
                    color: #ffcc00
                }
                &.image{
                    color: #00bcd4
                }
                &.share{
                    color: #a18fe8
                }
            }
        }
    }
    .animated {
        -webkit-animation-duration: 1s;
        animation-duration: 1s;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
    }

    @keyframes fadeInDownBig {
        from {
            opacity: 0;
            -webkit-transform: translate3d(0, -2000px, 0);
            transform: translate3d(0, -2000px, 0);
        }
        to {
            opacity: 1;
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }
    }

    .fadeInDownBig {
        -webkit-animation-name: fadeInDownBig;
        animation-name: fadeInDownBig;
    }

    @-webkit-keyframes fadeInRight {
        from {
            opacity: 0;
            -webkit-transform: translate3d(100%, 0, 0);
            transform: translate3d(100%, 0, 0);
        }
        to {
            opacity: 1;
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }
    }

    @keyframes fadeInRight {
        from {
            opacity: 0;
            -webkit-transform: translate3d(100%, 0, 0);
            transform: translate3d(100%, 0, 0);
        }
        to {
            opacity: 1;
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }
    }

    .fadeInRight {
        -webkit-animation-name: fadeInRight;
        animation-name: fadeInRight;
    }

    @-webkit-keyframes fadeOutRight {
        from {
            opacity: 1;
        }
        to {
            opacity: 0;
            -webkit-transform: translate3d(100%, 0, 0);
            transform: translate3d(100%, 0, 0);
        }
    }

    @keyframes fadeOutRight {
        from {
            opacity: 1;
        }
        to {
            opacity: 0;
            -webkit-transform: translate3d(100%, 0, 0);
            transform: translate3d(100%, 0, 0);
        }
    }

    .fadeOutRight {
        -webkit-animation-name: fadeOutRight;
        animation-name: fadeOutRight;
    }

    @-webkit-keyframes fadeOutUp {
        from {
            opacity: 1;
        }
        to {
            opacity: 0;
            -webkit-transform: translate3d(0, -100%, 0);
            transform: translate3d(0, -100%, 0);
        }
    }

    @keyframes fadeOutUp {
        from {
            opacity: 1;
        }
        to {
            opacity: 0;
            -webkit-transform: translate3d(0, -100%, 0);
            transform: translate3d(0, -100%, 0);
        }
    }

    .fadeOutUp {
        -webkit-animation-name: fadeOutUp;
        animation-name: fadeOutUp;
    }

    .lang-en {
        .tip-num {
            width: 400px;
            &.kp-left {
                width: 388px;
            }
        }
    }
</style>
